import { ConfigProvider, theme } from 'antd';
import locale from 'antd/es/date-picker/locale/en_US';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from '@/context/AuthContext';
import { queryClient } from '@/lib/query/index';
import { QueryClientProvider } from '@tanstack/react-query';
import AppRoutes from './routes';
function App() {
  return (
    // Wrap everything in QueryClientProvider first
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <ConfigProvider
          locale={locale.lang}
          theme={{
            token: {
              // Primary Colors
              colorPrimary: '#ff9900', // Amazon's primary orange
              colorInfo: '#146eb4', // Amazon's blue
              colorTextBase: '#232f3e', // Amazon's dark navy
              colorBgContainer: '#ffffff',
              colorBgLayout: '#f2f2f2', // Amazon's light gray
              colorBorder: '#232f3e20', // Amazon's navy with opacity

              // Typography
              fontFamily: 'Sen, -apple-system, BlinkMacSystemFont, sans-serif',
              fontSize: 14,

              // Layout
              borderRadius: 2,
              controlHeight: 36,
              lineWidth: 1,

              // Spacing
              marginXS: 8,
              marginSM: 12,
              marginMD: 16,
              paddingSM: 12,
              paddingMD: 16,
              paddingLG: 24,
            },
            components: {
              Button: {
                controlHeight: 36,
                paddingInline: 16,
                colorPrimaryHover: '#ff9900e6',
                borderRadius: 2,
              },
              Input: {
                controlHeight: 36,
                paddingInline: 12,
                borderRadius: 2,
                colorBorder: '#232f3e40',
              },
              Select: {
                controlHeight: 36,
                borderRadius: 2,
                colorBorder: '#232f3e40',
              },
              Menu: {
                itemSelectedBg: '#f2f2f2',
                itemSelectedColor: '#146eb4', // Updated from colorItemTextSelected
                itemHoverBg: '#f2f2f2',
              },
              Table: {
                headerBg: '#fff7e6',
              },
            },
            algorithm: theme.compactAlgorithm,
          }}
        >
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
          
        </ConfigProvider>
      </HelmetProvider>
    </QueryClientProvider>
  );
}

export default App;
